import React, { FC } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Button, Row, Col } from "antd";
import {
  Login,
  Register,
  Resend,
  ResetPin,
  EnterEmailNumber,
} from "../../components/Auth";
import VerifyCode from "components/Auth/VerifyCode";
import "./index.scss";

const Auth: FC<{ socket: ISocket }> = ({ socket }) => {
  return (
    <Row className="auth-layout">
      <Col sm={24} md={12}>
        <Switch>
          <Route exact path="/auth">
            <Redirect to="/auth/login" />
          </Route>
          <Route path="/auth/login"
            // component={Login}
            render={(props) => <Login {...props} socket={socket} />}
          />
          <Route path="/auth/register" component={Register} />
          <Route path="/auth/pin/resend" component={Resend} />
          <Route path="/auth/pin/resetpin" component={ResetPin} />
          <Route path="/auth/pin/reset" component={EnterEmailNumber} />
          <Route path="/auth/pin/verify" component={VerifyCode} />
        </Switch>
      </Col>
      <Col sm={24} md={12}>
        <div className="welcome-text">
          <h3>The Unified Communication of Things</h3>
          <p>Turning raw data into Actionable Intelligence.</p>
          <div className="d-flex">
            <Button type="primary">Learn More</Button>
            <Button type="default" className="ml-2 request-demo">
              Request Live Demo
            </Button>
          </div>
        </div>
        <div className="bg-icons">
          <img alt="1" src="/images/home.png" className="bg-icon home-png" />
          <img alt="1" src="/images/audio.png" className="bg-icon audio-png" />
          <img alt="1" src="/images/place.png" className="bg-icon place-png" />
        </div>
      </Col>
    </Row>
  );
};

export default Auth;
